import { createStore, sample } from 'effector';
import { createAddCurrencyModel } from 'features/add-currency';
import { createAddWalletModel } from 'features/add-wallet';
import { createBlockWalletModel } from 'features/block-wallet';
import { createDeleteWalletModel } from 'features/delete-wallet';
import { createDepositWalletModel } from 'features/deposit-wallet';
import { createEditWalletModel } from 'features/edit-wallet';
import { createResetLimitModel } from 'features/reset-limit';
import { createUnblockWalletModel } from 'features/unblock-wallet';
import { createWithdrawWalletModel } from 'features/withdraw-wallet';
import { viewerModel } from 'entities/viewer';
import { createWalletRegistryModel } from 'entities/wallet';
import { accountPageModel } from './account-page-model';

const $availableCurrencies = createStore<string[]>([]);

const resetLimitModel = createResetLimitModel();

const addWalletModel = createAddWalletModel({
	$accountId: accountPageModel.$accountId,
	$availableCurrencies,
	$isCurrentAccount: accountPageModel.$isCurrentAccount,
});

const addCurrencyModel = createAddCurrencyModel();

const withdrawWalletModel = createWithdrawWalletModel();

const depositWalletModel = createDepositWalletModel();

const blockWalletModel = createBlockWalletModel();

const unblockWalletModel = createUnblockWalletModel();

const deleteWalletModel = createDeleteWalletModel();

const editWalletModel = createEditWalletModel();

const walletRegistryModel = createWalletRegistryModel({
	onDelete: [deleteWalletModel.mutation.finished.success],
	onUpdate: [
		accountPageModel.accountIdSet,
		blockWalletModel.mutation.finished.success,
		unblockWalletModel.mutation.finished.success,
		addWalletModel.addWalletMutation.finished.success,
		editWalletModel.editWalletMutation.finished.success,
		resetLimitModel.mutation.finished.success,
		withdrawWalletModel.withdrawWalletMutation.finished.success,
		depositWalletModel.depositWalletMutation.finished.success,
		deleteWalletModel.mutation.finished.success,
		addCurrencyModel.addCurrencyMutation.finished.success,
	],
});

sample({
	clock: walletRegistryModel.query.$data,
	source: viewerModel.$account,
	fn: (account, data) =>
		account?.wallets
			.map((wallet) => wallet.currency)
			.filter(
				(currency) => !(data?.rows.some((wallet) => wallet.currency === currency) ?? false),
			) ?? [],
	target: $availableCurrencies,
});

sample({
	clock: addCurrencyModel.addCurrencyMutation.finished.success,
	source: viewerModel.$account,
	filter: Boolean,
	fn: (account) => account.id,
	target: viewerModel.getAccountQuery.start,
});

export const accountPageWalletsModel = {
	walletRegistryModel,
	addWalletModel,
	withdrawWalletModel,
	depositWalletModel,
	blockWalletModel,
	unblockWalletModel,
	deleteWalletModel,
	editWalletModel,
	resetLimitModel,
	addCurrencyModel,
};
